jQuery(document).on('click', '#addTOcart', function(e){
  const $btn = jQuery(this);
  if ($btn.hasClass('uploading')) return; // Already in process

  $btn.addClass('uploading').prop('disabled', true);
  
  const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
  const previewId = generateUUID();
  
  handleUpload(fileInputs, previewId).finally(() => {
    $btn.removeClass('uploading').prop('disabled', false);
  });
});
  
function generateUUID() {
  return 'xxxxxa-xxxxxb-xxxxx4-xxxxx5-xxxxcx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  // if(temp_images.length === 0){
  //   alert("Please select at least one image.");
  //   return;
  // }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties[User Upload '+int+']">');
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .hidden.product-form__submit').trigger('click');
  } catch (error) {
    console.error("Upload error:", error);
  }
}

function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}